import { esAnimePalettes } from "../../../../Posts/05-tematicas/01-animes/animePalettes.js";
import { localizeTematicPalettes } from "../../../../src/helpers/localizeTematicPalettes.js";
import * as React from 'react';
export default {
  esAnimePalettes,
  localizeTematicPalettes,
  React
};